import { useEffect, useState } from "react";
import { Box, Button, FormControl, FormGroup, FormLabel, Modal, TextField, Typography } from "@mui/material";
import { Category } from "./ProductType";
import { createCategory, updateCategory } from "services/ProductService";

interface CategoryModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  initialValues: Category;
  isEdit: boolean;
}

export const CategoryModal: React.FC<CategoryModalProps> = ({ open, onClose, onSubmit, initialValues, isEdit }) => {
  const [category, setCategory] = useState<Category>({
    ...initialValues
  });

  useEffect(() => {
    if (open) {
      setCategory({ ...initialValues });
    }
  }, [open, initialValues]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCategory({ ...category, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isEdit) {
      await updateCategory({
        id: category.id,
        name: category.name,
        code: category.code,
        description: category.description,
      });
    } else {
      await createCategory({
        name: category.name,
        code: category.code,
        description: category.description,
      });
    }

    await onSubmit();
  };

  return <Modal open={open} onClose={onClose}>
    <Box
      component="form"
      sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}
      onSubmit={handleSubmit}
    >
      <Typography variant="h6">{isEdit ? 'Cập nhật danh mục' : 'Thêm danh mục'}</Typography>
      <FormGroup>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="name">Tên danh mục</FormLabel>
          <TextField
            id="name"
            name="name"
            placeholder="Tên danh mục"
            autoComplete="name"
            autoFocus
            value={category.name}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="description">Mô tả</FormLabel>
          <TextField
            id="description"
            name="description"
            placeholder="Mô tả danh mục"
            autoComplete="description"
            value={category.description}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <FormLabel htmlFor="code">Mã danh mục</FormLabel>
          <TextField
            id="code"
            name="code"
            placeholder="Mã danh mục"
            autoComplete="code"
            value={category.code}
            onChange={handleChange}
            disabled={isEdit}
          />
        </FormControl>
      </FormGroup>
      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button onClick={onClose} sx={{ mr: 1 }}>Hủy</Button>
        <Button type="submit" variant="contained" color="primary">{isEdit ? 'Cập nhật' : 'Thêm'}</Button>
      </Box>
    </Box>
  </Modal>;
};